// export const AUTH_TOKEN = 'auth_token'
export const AUTH_TOKEN = "auth_token";
export const AUTH_DETAILS = "auth_details";
export const MENU_ITEMS = "menu_items";